import React from "react";

const enlaces = ["Sobre Nosotros", "Contacto", "Preguntas Frecuentes", "Política de Privacidad", "Términos del Servicio"];

const Footer = () => {
  return (
    <footer className="bg-gray-700 text-white flex justify-center">
      <div className="flex max-w-[960px] flex-1 flex-col">
        <div className="flex flex-col gap-6 px-5 py-10 text-center">
          <div className="flex flex-wrap items-center justify-center gap-6">
            {enlaces.map((enlace, index) => (
              <a
                key={index}
                className="text-white text-base font-normal leading-normal min-w-40 hover:underline"
                href="#"
              >
                {enlace}
              </a>
            ))}
          </div>
          <p className="text-white text-base font-normal leading-normal">
            @2024 Fashion Hub. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
